
































































































import Vue, { PropOptions } from "vue";
import { Campaign } from "@/models";
import { CONSTANTS } from "@/config/constants";
import { Selection } from "@/utils/selection";
import {
  hasTokenOrLinkOnLeft,
  parseCampaignEditableText,
  normalizeOnPasteText,
  keyEventHasSpecialCharacters,
  removeTokenOrLinkOnLeft,
} from "@/utils/editableTextMessage";

import CampaignService from "@/services/CampaignService";
import ButtonAddField from "@/components/campaign/ButtonAddField.vue";
import { iconService } from "@/services/IconService";

export default Vue.extend({
  components: { ButtonAddField },
  props: {
    campaign: Object as PropOptions<Campaign>,
    editable: Boolean,
    isMobile: Boolean,
    height: {
      type: Number,
      default: 550,
    },
  },
  data() {
    return {
      selection: {} as Selection,
      currentIndex: 0,
      shortLinkStyles: {
        top: "0px",
        right: "0px",
      },
      oldMessage: this.campaign.textMessage,
      textMessages: CampaignService.extractTextToMessages(
        this.campaign.textMessage
      ),
      messageSize: 0,
      csvArray: undefined,
      isInvalid: false,
    };
  },
  mounted() {
    this.refreshShortLinkButtonPosition();
    if (this.editable) {
      this.setTextMessage(this.campaign.textMessage);
    }
    if (!this.campaign.textMessage) {
      this.doActionToInput(this.currentIndex, (element) => {
        this.selection = new Selection(element) as any;
      });
    }
  },
  methods: {
    onPaste(event: any) {
      const pastedText = normalizeOnPasteText(event);
      const msg = pastedText.replace(
        /(https?:\/\/[^\s]+)/g,
        '<a href="$1" target="__blank">$1</a>'
      );
    },
    setBiggerText(field: string) {
      const plainField = field.replace(/[^\w\s]/gi, "");
      const csvArray = JSON.parse(window.localStorage.getItem("@csv-array"));
      if (
        this.campaign.audienceCustomerList &&
        this.campaign.audienceCustomerList.length
      ) {
        const tokensArr = [];
        this.campaign.audienceCustomerList.map((customer) => {
          customer.tokens.map((token) => {
            tokensArr.push(token.value);
          });
        });

        const stringLength = tokensArr.reduce((max, el) => {
          return el.length > max ? el.length : max;
        }, 0);
        return stringLength;
      } else {
        if (csvArray) {
          const tokenIndex = csvArray[0].findIndex(
            (csv: string) => csv.replace(/[^\w\s]/gi, "") === plainField
          );
          if (tokenIndex < 0) {
            return field.length;
          }
          if (this.campaign.audienceFileTokenMapping.length) {
            this.campaign.audienceFileTokenMapping.map((token, index) => {
              if (
                token.token.replace(/[^\w\s]/gi, "") ===
                csvArray[0][tokenIndex].replace(/[^\w\s]/gi, "")
              ) {
                this.campaign.audienceFileTokenMapping[index].fileColumn =
                  csvArray[0][tokenIndex];
              }
            });
          }

          csvArray.shift();
          const csvData = [];
          csvArray.map((csv) => {
            csvData.push(csv[tokenIndex]);
          });
          const stringLength = csvData.reduce((max, el) => {
            return el.length > max ? el.length : max;
          }, 0);

          return stringLength;
        }
      }
      return field.length;
    },
    onAddField(field: string, type: string | null) {
      const textMessage = this.textMessages[this.currentIndex] || "";
      const position = this.selection.fullOffset || textMessage.length;
      const newText = [
        textMessage.slice(0, position),
        field + " ",
        textMessage.slice(position),
      ].join("");
      this.selection.currentOffset =
        this.selection.fullOffset + field.length + 1;
      const newArray = [...this.textMessages];
      newArray[this.currentIndex] = newText;
      this.$emit("update", {
        textMessage: newArray.join(""),
      });
    },
    onClickTextMessage(event: any, index: number) {
      this.currentIndex = index;
      const element = event.target;
      this.selection = new Selection(element) as any;
      this.selection.saveCurrentSelection();
    },
    parseTextMessageToHTML(text: string) {
      return parseCampaignEditableText(
        text,
        this.$store.state.campaign.campaignShortLinks
      );
    },
    onKeyUp(event: any, index: number) {
      if (
        ["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown"].includes(event.code)
      ) {
        this.selection.saveCurrentSelection();
      }
    },
    onInput(event: any, index: number) {
      const arr = event.target.innerHTML.split(" ");
      this.isInvalid = arr.some(
        (text) => /[{}]/.test(text) && !text.match(/(?<!{){{[^{}]*}}(?!})/g)
      );

      if (event.inputType === "deleteContentBackward") {
        const msg = this.textMessages[this.currentIndex];
        this.selection.saveCurrentSelection();
        const newMessage = removeTokenOrLinkOnLeft(
          msg,
          this.selection.fullOffset
        );
        if (newMessage) {
          const newArray = [...this.textMessages];
          newArray[this.currentIndex] = newMessage;
          this.selection.currentOffset -= msg.length - newMessage.length - 1;
          this.$emit("update", { textMessage: newArray.join("") });
          return;
        }
      }
      if (keyEventHasSpecialCharacters(event)) {
        event.target.innerHTML = event.target.innerHTML.replace(event.data, "");
        this.selection.currentOffset = this.selection.fullOffset;
        this.selection.restoreSelection();
      } else {
        const element = event.target;
        if (
          event.which !== 13 &&
          element.innerText !== this.textMessages[index]
        ) {
          this.selection = new Selection(element) as any;
          this.selection.saveCurrentSelection();
          this.textMessages[index] = event.target.innerText;
          if (this.oldMessage !== this.textMessages.join("")) {
            let msg = this.textMessages[this.currentIndex];
            const cursorIndex = this.selection.fullOffset;
            if (
              hasTokenOrLinkOnLeft(msg, cursorIndex) &&
              event.inputType !== "deleteContentBackward"
            ) {
              msg = `${msg.slice(0, cursorIndex)} ${msg.slice(cursorIndex)}`;
              this.selection.currentOffset += 1;
            }
            const newArray = [...this.textMessages];
            newArray[this.currentIndex] = msg;
            this.$emit("update", { textMessage: newArray.join("") });
          }
        }
      }
    },
    refreshShortLinkButtonPosition() {
      const inputs = document.querySelectorAll(".input-sms");
      const last: any = inputs[inputs.length - 1];
      const offsetTop = last.offsetTop;
      const offsetHeight = last.offsetHeight;
      const newTop = `${offsetTop + offsetHeight - 30}px`;
      if (newTop !== this.shortLinkStyles.top) {
        const offsetWidth = last.offsetWidth;
        this.shortLinkStyles = {
          top: newTop,
          right: `${offsetWidth - 10}px`,
        };
      }
    },
    doActionToInput(inputIndex: number, action: (element: any) => void) {
      const selector = this.$refs[`message${inputIndex}`] as any;
      if (selector && selector.length) {
        action(selector[0]);
      }
    },
    refreshInputHTMLAndCaret(
      oldInputsLength: number,
      inputsLength: number,
      oldIndex: number
    ) {
      try {
        for (let i = 0; i < inputsLength; i++) {
          this.doActionToInput(i, (element) => {
            element.innerHTML = this.parseTextMessageToHTML(
              this.textMessages[i]
            );
          });
        }
        if (this.selection.currentOffset === 0 && oldIndex !== 0) {
          this.doActionToInput(this.currentIndex, (element) => {
            element.focus();
            this.selection.setCaretAtEnd(element);
          });
        } else {
          this.doActionToInput(this.currentIndex, (element) => {
            element.focus();
            this.selection.restoreSelection();
          });
        }
      } catch (error) {
        if (error.message === `Cannot read property 'node' of undefined`) {
          this.doActionToInput(this.currentIndex, (element) => {
            element.focus();
            this.selection.setCaretAtEnd(element);
          });
        } else {
          this.doActionToInput(this.currentIndex, (element) => {});
        }
      }
    },
    setTextMessage(val: string) {
      this.textMessages = CampaignService.extractTextToMessages(val);
      const oldLength = CampaignService.extractTextToMessages(
        this.oldMessage
      ).length;
      const newLength = CampaignService.extractTextToMessages(val).length;
      const delay = oldLength !== newLength ? 50 : 0;
      const oldIndex = this.currentIndex;

      if (delay) {
        setTimeout(() => {
          this.refreshInputHTMLAndCaret(oldLength, newLength, oldIndex);
          this.refreshShortLinkButtonPosition();
        }, delay);
      } else {
        this.refreshInputHTMLAndCaret(oldLength, newLength, oldIndex);
        this.refreshShortLinkButtonPosition();
      }
      this.oldMessage = val;
    },
  },
  watch: {
    "campaign.textMessage"(val) {
      this.messageSize = val.length;
      const tokens = val.match(/(?<!{){{[^{}]*}}(?!})/g);
      var re =
        /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim;
      const links = val.match(re);

      if (links && links.length) {
        links.map(() => {
          this.messageSize += 2;
        });
      }

      if (tokens && tokens.length) {
        tokens.map((token) => {
          this.messageSize -= token.length;
          this.messageSize += this.setBiggerText(token);
        });
      }
      this.setTextMessage(val);
    },
    messageSize(size) {
      if (size > 160 || this.isInvalid) {
        this.$emit("invalid", true);
      } else {
        this.$emit("invalid", false);
      }
    },
  },
});
